import * as footer from './footer.json'
import * as icons from './icons.json'
import * as cpf from './cpf.json'
import * as general from './general.json'
import * as components from './components.json'
import * as header from './header.json'
import * as cnpj from './cnpj.json'
import * as rg from './rg.json'
import * as http from './http.json'
import * as privacyPolicy from './privacyPolicy.json'
import * as termsOfUse from './termsOfUse.json'
import * as about from './about.json'
import * as contact from './contact.json'
import * as changelog from './changelog.json'
import * as seo from './seo.json'

const pt = {
  translation: {
    footer,
    icons,
    cpf,
    general,
    components,
    header,
    cnpj,
    rg,
    http,
    privacyPolicy,
    termsOfUse,
    about,
    contact,
    changelog,
    seo,
  },
}

export default pt
